import { useState, useEffect, useRef } from "react";
import useStyles from "./styles/whymyfitsociety";
import { whyMyfitsocietyData } from "../../static/new-landing-page/new-landing-data";
import ButtonBlue from "../../components/ButtonBlue";
import { withTranslation } from "../../i18n";
import ChecklistItem from "./components/ChecklistItem";
import { Hidden } from "@material-ui/core";


const WhyMyfitsociety = ({ t, i18n }) => {
    const [currentSlide, setCurrentSlide] = useState(0);
    const classes = useStyles();
    const language = i18n.language
    const data = whyMyfitsocietyData[language] || whyMyfitsocietyData.en
    const intervalRef = useRef(null);

    // Auto slide tiap 5 detik
    useEffect(() => {
        const startAutoSlide = () => {
            intervalRef.current = setInterval(() => {
                setCurrentSlide((prevSlide) => {
                    // Jika sudah di slide terakhir, kembali ke slide 0
                    if (prevSlide >= data.slide.desktop.length - 1) {
                        return 0;
                    }
                    // Jika belum di slide terakhir, lanjut ke slide berikutnya
                    return prevSlide + 1;
                });
            }, 5000); // 5 detik = 5000ms
        };

        startAutoSlide();

        // Cleanup interval ketika component unmount
        return () => {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
            }
        };
    }, [data.slide.desktop.length]);

    // Function untuk handle click pada content item
    const handleContentClick = (index) => {
        // Set slide sesuai index yang diklik
        setCurrentSlide(index);

        // Reset timer dengan clear interval yang ada dan buat yang baru
        if (intervalRef.current) {
            clearInterval(intervalRef.current);
        }

        // Buat interval baru untuk reset timer
        intervalRef.current = setInterval(() => {
            setCurrentSlide((prevSlide) => {
                if (prevSlide >= data.slide.desktop.length - 1) {
                    return 0;
                }
                return prevSlide + 1;
            });
        }, 5000);
    };

    function renderImage() {
        return (
            <div className={classes.ctnImage}>
                <div className={classes.ctnImageWrapper}>
                    <Hidden smDown>
                        <img src={data.slide.desktop[currentSlide]} alt="why-myfitsociety" loading="lazy" />
                    </Hidden>
                    <Hidden mdUp>
                        <img src={data.slide.mobile[currentSlide]} alt="why-myfitsociety" loading="lazy" />
                    </Hidden>
                </div>
            </div>
        )
    }

    function renderContent() {
        return (
            <div className={classes.ctnContent}>
                <h2 className={classes.title}>{data.title}</h2>
                <div className={classes.ctnChecklist}>
                    {data.content.map((item, index) => (
                        <ChecklistItem item={item} index={index} key={index} currentSlide={currentSlide} handleContentClick={handleContentClick} />
                    ))}
                </div>

            </div>
        )
    }
    return (
        <div className={classes.root}>
            <div className={classes.container}>
                {renderImage()}
                {renderContent()}
            </div>
        </div>
    );
};

export default withTranslation(["myfitsociety"])(WhyMyfitsociety);